import { urls } from '@/helper/urls';
import { lazyLoad } from './visibilityObserver';
const __default__ = {
    props: {
        icon: { type: String, default: '' },
        image: { type: String, default: '' },
        size: { type: Number, default: 35 },
        badgeVariant: { type: String, default: 'secondary' },
        badgeSize: { type: String, default: '75%' },
        variant: { type: String, default: undefined },
        tooltip: { type: String, default: undefined },
        ariaLabel: { type: String, default: undefined },
        transparent: { type: Boolean, default: false },
        shape: { type: String, default: 'rounded' },
        // Object with id, name, avatar and (optionally) isSleeping properties.
        user: { type: Object, default: null },
        // Uses the given string as href. If undefined is provided, a link to the given user profile is used.
        href: { type: String, default: undefined },
        // Further options provided to b-avatar (TODO remove if unused)
        options: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            lazyLoaded: false,
            observer: null,
        };
    },
    computed: {
        imageSrc() {
            const prefix = [
                [35, 'mini_q_'],
                [50, '50_q_'],
                [Infinity, '130_q_'],
            ].find(x => x[0] >= this.size)[1];
            const image = this.image || this.user?.avatar;
            if (!this.lazyLoaded || !image) {
                return '/img/' + prefix + 'avatar.png';
            }
            return this.$url('upload', image, this.size, this.size);
        },
        computedHref() {
            if (this.href === '') {
                return null;
            }
            if (typeof this.href === 'string') {
                return this.href;
            }
            if (this.user?.id) {
                return urls.profile(this.user.id);
            }
            return null;
        },
        isButton() {
            return !this.computedHref && !!this.$listeners.click;
        },
        computedAriaLabel() {
            return this.ariaLabel ?? this.user?.name ?? undefined;
        },
        computedTooltip() {
            if (typeof this.tooltip === 'string') {
                return this.tooltip;
            }
            if (this.user) {
                return this.user?.name;
            }
            return '';
        },
        computedVariant() {
            if (this.imageSrc.endsWith('avatar.png'))
                return 'light';
            if (this.imageSrc)
                return '';
            return this.variant;
        },
        isSleeping() {
            if (!this.user)
                return false;
            return this.user.isSleeping;
        },
        sleepImageSrc() {
            if (!this.isSleeping)
                return '';
            const size = [35, 50].find(x => x >= this.size) ?? 130;
            return `url('/img/sleep${size}x${size}.png')`;
        },
    },
    mounted() {
        if (typeof IntersectionObserver === 'undefined' || !(this.image || this.user?.avatar)) {
            this.lazyLoaded = true;
            return;
        }
        lazyLoad(this.$el, () => { this.lazyLoaded = true; });
    },
    methods: {
        intersectionHandler(evt) {
            const isIntersecting = evt[evt.length - 1].isIntersecting;
            if (this.observer && isIntersecting) {
                this.lazyLoaded = true;
                this.observer.disconnect();
                this.observer = null;
            }
        },
    },
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
    _useCssVars((_vm, _setup) => ({
        "3c8e2cdd": (_vm.badgeSize),
        "e26c0ece": (_vm.sleepImageSrc)
    }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__
    ? (props, ctx) => { __injectCSSVars__(); return __setup__(props, ctx); }
    : __injectCSSVars__;
export default __default__;
